import { forwardRef } from '@angular/core';
import { Type } from 'class-transformer';

export class User {
    public id: string;
    public username: string;
    public email?: string;
    public name: string;
    public status: number;

    @Type(forwardRef(() => Date) as any)
    public updatedAt: Date;
}
